import { Controller } from "@hotwired/stimulus"

// A 1-5 star rating that submits on click, so a review is one gesture rather
// than "type a number, then find the save button".
//
// The stars are real <button>s inside the row's form: keyboard and screen
// readers get the semantics for free, and the whole thing still works if
// Stimulus never connects — the button posts its value and the row re-renders.
// This controller only adds the hover preview and the instant fill, so the
// star responds before the turbo round-trip lands.
export default class extends Controller {
  static targets = ["star"]
  static values = { rating: Number }

  connect() {
    this.paint(this.ratingValue)
  }

  preview(event) {
    this.paint(Number(event.currentTarget.dataset.starRatingValue))
  }

  reset() {
    this.paint(this.ratingValue)
  }

  // Clicking the star you already have clears the rating, which is the only way
  // back to "unrated" once you have picked one.
  select(event) {
    const chosen = Number(event.currentTarget.dataset.starRatingValue)
    const next = chosen === this.ratingValue ? 0 : chosen
    this.ratingValue = next
    this.paint(next)
    event.currentTarget.closest("form")?.requestSubmit?.()
  }

  ratingValueChanged() {
    const field = this.element.querySelector("input[name='video[rating]']")
    if (field) field.value = this.ratingValue || ""
  }

  paint(upTo) {
    this.starTargets.forEach((star) => {
      const filled = Number(star.dataset.starRatingValue) <= upTo
      star.textContent = filled ? "★" : "☆"
      star.classList.toggle("is-filled", filled)
    })
  }
}
